import {
  Box,
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  VStack,
  Text,
  Icon,
} from "@chakra-ui/react";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";
import { BsBraces } from "react-icons/bs";
import { IoMdMore } from "react-icons/io";

const PopoverMenu = ({ handleDelete }) => {
  return (
    <Box position="relative">
      <Popover placement="bottom-end">
        {" "}
        {/* Opens popover on the left side */}
        <PopoverTrigger p={0}>
          <IconButton
            aria-label="Options"
            icon={<IoMdMore />}
            size="sm"
            p={0}
            variant="ghost"
            minW="auto"
            h="auto"
          />
        </PopoverTrigger>
        <PopoverContent
          bg="white"
          color="black"
          w="auto"
          borderRadius="md"
          boxShadow="lg"
        >
          <PopoverArrow bg="white" />
          <PopoverCloseButton />
          <PopoverBody>
            <VStack align="start" spacing={2}>
              <Box
                display="flex"
                alignItems="center"
                cursor="pointer"
                _hover={{ bg: "gray.100" }}
                borderRadius="md"
              >
                <Icon as={EditIcon} mr={2} />
                <Text>Rename block</Text>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                cursor="pointer"
                _hover={{ bg: "gray.100" }}
                borderRadius="md"
              >
                <Icon as={BsBraces} mr={2} />
                <Text>Execute for all variants</Text>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                cursor="pointer"
                _hover={{ bg: "red.100" }}
                borderRadius="md"
                onClick={() => handleDelete()}
              >
                <Icon as={DeleteIcon} mr={2} color="red.500" />
                <Text color="red.500">Delete block</Text>
              </Box>
            </VStack>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};

export default PopoverMenu;
